var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import tinycolor from "tinycolor2";
export var SmallTitle = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  opacity: 0.5;\n  color: ", ";\n  font-size: 1.2rem;\n  font-weight: 500;\n  letter-spacing: 1.2px;\n  line-height: 1.4em;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"], ["\n  display: inline-block;\n  opacity: 0.5;\n  color: ",
    ";\n  font-size: 1.2rem;\n  font-weight: 500;\n  letter-spacing: 1.2px;\n  line-height: 1.4em;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.generalContent.text.alt.color)
        .lighten(20)
        .toString();
});
var templateObject_1;
//# sourceMappingURL=SmallTitle.js.map